// extracted by mini-css-extract-plugin
module.exports = {"Quiz":"Quiz_Quiz__2TVFv","QuizWrapper":"Quiz_QuizWrapper__11EFW"};